






import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { downLoadImg } from '@/api/order-management';

@Component
export default class AuthImg extends Vue {
  @Prop({ default: '' }) private value?: string;
  imgSrc = '';
  get getImgSrc() {
    return this.value;
  }
  created() {
    if (this.getImgSrc) {
      this.showImg();
    }
  }
  async showImg() {
    let self = this;
    const { data } = await downLoadImg({ fileName: '20200317182104879108005001100926/image/2020/03/30/111tt.jpg' });
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = function(e: any) {
      self.imgSrc = e.target.result;
    };
  }
}
